module.exports = __webpack_public_path__ + "img/symbol_2.2f614eca.png";